<template>
  <div class="sobre">
    <br>
    <v-row class="text-center"  >
      <v-row justify="center" class="mb-5">
        <img :src="logo_1" width="60%">
      </v-row>
      
      <v-col class="grey darken-4" cols="12">
        <v-row justify="center">
          <img width="90%"  :src="sobre" >
                
            </v-row>
        </v-col>

    </v-row>
      
     <v-layout row justify-center class="mt-7" v-for="sessao in sessoes" :key="sessao.id">
                    <v-flex xs10 sm10 md10  class="grey darken-4 white--text text-center">
                    <v-layout row justify-center class="ma-1 pb-7">
                        <v-flex xs12 class="pa-5">
                            <h1 class="display-3">{{sessao.descricao}}</h1>
                        </v-flex>
                        
                        <v-flex xs10 sm10 md4 lg3 class="mb-2" v-for="img in sessao.fotos" :key="img.id">
    
                            
                            <a :href="img.imageUrl" target="_blank"><v-img width="" class="rounded-lg ma-2" aspect-ratio="1.0" :src="img.imageUrl" >
                            </v-img></a>
                            
                        </v-flex>

                    
                    </v-layout>

                
                </v-flex>
                </v-layout>


    <!-- <v-layout row justify-center class="mt-2">
         <v-flex xs10 sm10 md10  class="grey darken-4 white--text text-center">
          <v-layout row justify-center class="ma-1 pb-7">
            <v-flex xs12 class="pa-5">
              <h1 class="display-3">Veja nossos cortes KIDS</h1>
            </v-flex>
            <v-flex xs10 sm10 md4 lg3 class="mb-2" v-for="img in cortesKids" :key="img">
              <a  :href="img" target="_blank" >
                <v-img width="" class="rounded-lg ma-2" aspect-ratio="1.0" :src="img" >
              </v-img>
                </a>
            </v-flex>

           
        </v-layout>

     
      </v-flex>
      </v-layout>
    <v-layout row justify-center class="mt-2">
         <v-flex xs10 sm10 md10  class="grey darken-4 white--text text-center">
          <v-layout row justify-center class="ma-1 pb-7">
            <v-flex xs12 class="pa-5">
              <h1 class="display-3">Veja nossos cortes</h1>
            </v-flex>
            <v-flex xs10 sm10 md4 lg3 class="mb-2" v-for="img in cortes" :key="img">
              <a  :href="img" target="_blank" >
                <v-img width="" class="rounded-lg ma-2" aspect-ratio="1.0" :src="img" >
              </v-img>
                </a>
            </v-flex>

           
        </v-layout>

     
      </v-flex>
      </v-layout> -->


      <v-layout row justify-center>
        <v-flex xs12 sm12 class="text-center" >
            <img position="center"  width="60%" :src="logo"/>

        </v-flex>
      </v-layout>
  </div>
</template>

<script>

// import 'viewerjs/dist/viewer.css';
// import Viewer from "v-viewer/src/component.vue";
  import { refFotos, refSessoes } from '@/firebaseConfig' 


export default {
    components: {
      // Viewer
    },

    data(){
      return {
        
        logo: '/imgs/logo.PNG',
        logo_1: '/imgs/logo_1.PNG',
        sobre_1: '/imgs/sobre_1.jpg',
        sobre_1_2: '/imgs/sobre_1_feat.PNG',
        sobre: '/imgs/sobre.PNG',
        sessoes: []
        
      }
    },
    created(){
      this.carregarSessoes()
    },
    methods: {
      async carregarSessoes(){
            this.sessoes = []
            return refSessoes.orderBy("ordem", "asc").get().then(ref => {
                return ref.forEach(async sessao => {
                    // this.sessoes.push(sessao.data())
                    let sessaoRef = {...sessao.data(), fotos: []}
                    await refFotos.where("sessao.id", "==", sessaoRef.id ).get().then(ref => {
                        return ref.forEach(foto => {
                            // this.fotos.push(foto.data());
                            sessaoRef.fotos.push(foto.data())
                        });
                    });
                    this.sessoes.push(sessaoRef);
                })
            });

        },
    }
  }
</script>

<style lang="scss" scoped>
  .gradient{
        background-image: linear-gradient(to right, rgba(0, 0, 0, 0.4) 0%, transparent 150px);

  }
</style>